import { useEffect } from "react";
import './App.css';
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from './components/HomePage/Navbar';
import Hero from './components/HomePage/Hero';
import AboutUs from './components/HomePage/AboutUs';
import OurServices from './components/HomePage/OurServices';
import Footer from './components/HomePage/Footer';
import ContactUs from './components/EnquiryPage/ContactUs';
import WhyChooseUs from './components/AboutPages/WhyChooseUs';
import StrategicPartners from "./components/AboutPages/StrategicPartners";
import OurClients from "./components/AboutPages/OurClients";
import InfrastructureManagement from "./components/ServicesPages/InfrastructureManagement";
import ITHardwareDeploymentServices from "./components/ServicesPages/ITHardwareDeploymentServices";
import DeviceRental from "./components/ServicesPages/Device Rental";
import NetworkSecurity from "./components/ServicesPages/NetworkSecurity";
import CloudSolutions from "./components/ServicesPages/Cloud Solutions";
import FMSServices from "./components/ServicesPages/FMSServices";

function App() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/" && location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={
          <div className="bg-blue-50">
            <Hero />
            <OurServices />
            <AboutUs />
            <Footer />
          </div>
        } />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/aboutus/clients" element={<OurClients />} />
        <Route path="/aboutus/strategicpartners" element={<StrategicPartners />} />
        <Route path="/aboutus/whyus" element={<WhyChooseUs />} />
        <Route path="/services/cloud-solutions" element={<CloudSolutions />} />
        <Route path="/services/infra-management" element={<InfrastructureManagement />} />
        <Route path="/services/ITHardwareDeploymentServices" element={<ITHardwareDeploymentServices />} />
        <Route path="/services/network-security" element={<NetworkSecurity />} />
        <Route path="/services/device-rental" element={<DeviceRental />} />
        <Route path="/services/FMSServices" element={<FMSServices />} />

        
      </Routes>
    </>
  );
}

export default App;
